import { useQuery } from '@tanstack/react-query';

import { availabilityLeadsApi } from '@/lib/api/availability-leads.api';

import type { AvailabilityLeadQuery } from '@repo/shared-types';

export function useAvailabilityLeads(query?: Partial<AvailabilityLeadQuery>) {
  return useQuery({
    queryKey: ['availability-leads', query],
    queryFn: () => availabilityLeadsApi.getAvailabilityLeads(query),
  });
}
